import axios from 'axios';

const fetchGameDetails = async (formdata) => {
    try {
        formdata.bypass_status_filter = true;
        const response = await axios.post('/api/games/get-game-details', formdata);
        return response.data;
    } catch (error) {
        console.error('Error fetching game details:', error);
        throw new Error('Failed to fetch game details. Please try again later.');
    }
};

const fetchGames = async (formdata) => {
    try {
        const response = await axios.post('/api/games/get-games', formdata);
        return response.data;
    } catch (error) {
        console.error('Error fetching games:', error);
        throw new Error('Failed to fetch games. Please try again later.');
    }
};

const getArticleTitle = async (projectId, formdetails, page, records) => {
    const formdata = {
        projectId: projectId,
        filters: formdetails,
        page: page,
        records: records
    };
    try {
        const response = await axios.post('/api/games/get-article-title', formdata);
        return response.data;
    } catch (error) {
        console.error('Error fetching article title:', error);
        throw new Error('Failed to fetch article title. Please try again later.');
    }
};

const saveGamesSettings = async (formdata) => {
    try {
        const response = await axios.post('/api/games/save-games-config', formdata);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Unexpected response status while saving game settings.');
        }
    } catch (error) {
        console.error('Error in saving game settings:', error);
        throw new Error('Failed to save game settings. Please check your input and try again.');
    }
};

const getGamesSettings = async (formdata) => {
    try {
        const response = await axios.post('/api/games/get-games-config', formdata);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Unexpected response status while fetching game settings.');
        }
    } catch (error) {
        console.error('Error in fetching game settings:', error);
        throw new Error('Failed to fetch game settings. Please try again later.');
    }
};

// Custom Quiz APIs
// List via existing get-game-details
const listCustomQuizzes = async ({ project_id, page = 1, limit = 10, game_type = 'custom_quiz', start_date, end_date, custom_quiz_id }) => {
    try {
        const payload = { project_id, game_type, page, limit };

        // Add date filters if provided
        if (start_date) {
            payload.start_date = start_date;
        }
        if (end_date) {
            payload.end_date = end_date;
        }
        // Add custom_quiz_id filter if provided (for fetching single game)
        if (custom_quiz_id) {
            payload.custom_quiz_id = custom_quiz_id;
        }
        payload.bypass_status_filter = true; // To fetch all games including inactive ones

        const response = await axios.post('/api/games/get-game-details', payload);
        return response.data;
    } catch (error) {
        console.error('Error listing custom quizzes:', error);
        throw new Error('Failed to list custom quizzes.');
    }
};

const upsertCustomQuiz = async (formdata) => {
    try {
        const response = await axios.post('/api/games/custom-quiz/upsert', formdata);
        return response.data;
    } catch (error) {
        console.error('Error upserting custom quiz:', error);
        throw new Error('Failed to save custom quiz.');
    }
};

// delete/restore handled via status endpoint

const setCustomQuizStatus = async (formdata) => {
    try {
        const response = await axios.post('/api/games/custom-quiz/status', formdata);
        return response.data;
    } catch (error) {
        console.error('Error setting custom quiz status:', error);
        throw new Error('Failed to update custom quiz status.');
    }
};

const exportGameLeaderboard = async (payload, responseType = 'json') => {
    const config = {
        ...(responseType === 'blob' && { responseType: 'blob' }),
    };

    const response = await axios.post(
        '/api/games/leaderboard/export',
        payload,
        config
    );

    return responseType === 'blob' ? response : response.data;
};


export default {
    fetchGames,
    fetchGameDetails,
    getArticleTitle,
    saveGamesSettings,
    getGamesSettings,
    listCustomQuizzes,
    upsertCustomQuiz,
    setCustomQuizStatus,
    exportGameLeaderboard
};
